const pad = (n: number, width = 2) => String(Math.floor(n)).padStart(width, '0')

/** `1:02:03` or `02:03` — for timers and durations. */
export function formatDuration(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000))
  const h = Math.floor(total / 3600)
  const m = Math.floor((total % 3600) / 60)
  const s = total % 60
  return h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`
}

/** `00:02:03.250` — for marker lists and exports that editors import. */
export function formatTimecode(ms: number): string {
  const clamped = Math.max(0, Math.round(ms))
  const h = Math.floor(clamped / 3_600_000)
  const m = Math.floor((clamped % 3_600_000) / 60_000)
  const s = Math.floor((clamped % 60_000) / 1000)
  return `${pad(h)}:${pad(m)}:${pad(s)}.${pad(clamped % 1000, 3)}`
}

/**
 * Where a moment sits in the recorded material: takes play back to back and pauses are cut out.
 * Takes come in order; `durationMs: null` is the take still running. Null for a moment outside them.
 */
export function recordingOffset(
  takes: readonly { id: string; startedAt: number; durationMs: number | null }[],
  takeId: string | null,
  at: number,
): number | null {
  let before = 0
  for (const t of takes) {
    if (t.id === takeId) return before + Math.min(Math.max(0, at - t.startedAt), t.durationMs ?? Infinity)
    before += t.durationMs ?? 0
  }
  return null
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`
  const units = ['KB', 'MB', 'GB', 'TB']
  let value = bytes / 1024
  let unit = 0
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024
    unit++
  }
  return `${value.toFixed(value >= 100 ? 0 : 1)} ${units[unit]}`
}
